export default __webpack_public_path__ + "static/media/folajuNcake_w1024.a810a86a.jpeg";